export function includes<T>(array: T[], value: T): boolean
export function includes<T>(array: T[] | undefined, value: T): boolean
export function includes<T>(array: T[] | undefined, value: T): boolean {
  return array ? array.includes(value) : false
}
